<template>
  <div class="specialist">
    <Heading>Especialista e Leiloeiro</Heading>
    <div class="specialist-bottom">
      <v-avatar size="200px">
        <v-img :src="require('../../../assets/specialist-avatar.png')" />
      </v-avatar>
      <div class="specialist-content">
        <Heading
          font-weight="700"
          font-size="24px"
          line-height="36px"
          letter-spacing="-0.015em"
          color="#000000"
          class="specialist-content__name"
          level="2"
        >
          {{ specialist.name }}
        </Heading>
        <p class="specialist-content__bio">
          {{ specialist.bio }}
        </p>
        <Button width="130px">
          Ler mais
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import Heading from '@/components/Heading/Heading.vue';
import Button from '@/components/Button/Button.vue';

export default {
  name: 'ProductSpecialist',
  components: { Heading, Button },
  data() {
    return {
      specialist: {
        name: 'Nome do Especialista',
        bio:
          'Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est.',
      },
    };
  },
};
</script>

<style lang="scss">
@import '@/static/css/Variables.scss';
.specialist {
  padding: 75px 80px;

  @media (max-width: $md) {
    padding: 0 20px;
    margin-bottom: 40px;
  }

  @media (max-width: $lg) {
    h1 {
      font-size: 24px !important;
    }
  }

  &-bottom {
    display: flex;
    margin-top: 60px;
    @media (max-width: $md) {
      margin-top: 5px;
      flex-direction: column;
    }
  }
  &-content {
    margin-left: 65px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media (max-width: $md) {
      margin-left: 0;
      margin-top: 10px;
    }

    @media (max-width: $lg) {
      h2 {
        font-size: 18px !important;
      }
      p {
        font-size: 14px !important;
      }
    }

    &__bio {
      width: 50%;
      font-size: 18px;
      line-height: 22px;
      letter-spacing: -0.015em;
      color: rgba(0, 0, 0, 0.8);

      @media (max-width: $lg) {
        width: 100%;
      }
    }
  }
}
</style>
